import { CAMPAIGN } from '@chessbut/shared';
import { Countdown } from '../components/Countdown.tsx';
import { refreshSession, useSession } from '../lib/session.ts';
import { ArchiveList } from './Home.tsx';

export function DaysPage() {
  const { campaign } = useSession();
  if (!campaign) return <div className="page loading"><span className="spinner big" /></div>;
  const nextDay = (campaign.featured?.day ?? 0) + 1;
  return (
    <div className="page">
      <h1 className="chessbut">
        <span className="lead">
          chess, <span className="but">but</span>
        </span>
        <span className="twist">different every day</span>
      </h1>
      <p className="muted">
        A new variant drops every day at midnight New York time. Every one stays playable here. Started {CAMPAIGN.startDate}.
      </p>
      {campaign.nextDayHasVariant ? (
        <div className="next-day">
          <span className="day-badge is-past">Day {nextDay}</span>
          <span>
            drops in <b className="num">
              <Countdown to={campaign.nextDayAt} onDone={() => setTimeout(refreshSession, 1500)} />
            </b>
          </span>
          <span className="muted small">No peeking.</span>
        </div>
      ) : (
        <div className="next-day">
          <span className="day-badge is-past">Day {nextDay}</span>
          <span className="muted">is being built right now. Follow along on Instagram.</span>
        </div>
      )}
      <ArchiveList campaign={campaign} />
    </div>
  );
}
